export default [
    {
        "min_age": 13,
        "max_age": 64,
        "max_amount": 14,
        "min_amount": 1,
        "type": "adult",
        "age_selection": false,
        "translations": [
            {
                "name": "Adult",
                "short_description": "adult selection",
                "plural": "Adults",
                "language": { "code": "en-US" }
            },
            {
                "name": "Voksen",
                "plural": "Voksne",
                "short_description": "Voksen selection",
                "language": { "code": "no-NO" }
            }
        ]
    },
    {
        "min_age": 0,
        "max_age": 12,
        "max_amount": 10,
        "min_amount": 0,
        "type": "junior",
        "age_selection": true,
        "translations": [
            {
                "name": "Barn",
                "short_description": null,
                "plural": "Barn",
                "language": { "code": "no-NO" }
            },
            {
                "name": "Children",
                "short_description": null,
                "plural": "Childs",
                "language": { "code": "en-US" }
            }
        ]
    }
] as TAgeCategory[];